var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.maker && _vm.model && _vm.bodyDesign && _vm.trimLevel && _vm.engine
    ? _c(
        "b-card",
        { staticClass: "cd-car-info-card" },
        [
          _c(
            "b-container",
            { staticClass: "p-0" },
            [
              _c(
                "b-row",
                { staticClass: "p-0" },
                [
                  _c("b-col", { attrs: { cols: "12", sm: "12", md: "6" } }, [
                    _c("h2", [
                      _vm._v(
                        _vm._s(_vm.maker ? _vm.maker.label : "") +
                          " " +
                          _vm._s(_vm.model ? _vm.model.label : "")
                      )
                    ]),
                    _c("p", { staticClass: "cd-car-info-subline" }, [
                      _vm._v(" " + _vm._s(_vm.engine.label) + " "),
                      _vm.engine.technical_data.energy_efficiency ||
                      _vm.engine.technical_data.wltpData
                        ? _c(
                            "span",
                            {
                              staticClass: "cd-efficiency-mark",
                              attrs: {
                                id: "energyefficiency-target-" + _vm.engine.id
                              }
                            },
                            [
                              !_vm.isPluginHybrid(_vm.engine)
                                ? _c("span", {
                                    class:
                                      "mark-background " +
                                      _vm.calculateEnergyClass(_vm.engine)
                                  })
                                : _vm._e(),
                              _vm.isPluginHybrid(_vm.engine)
                                ? _c("span", {
                                    class:
                                      "mark-background efficiency-wltp-" +
                                      _vm
                                        .getWltpCo2ClassOnly(_vm.engine)
                                        .toLowerCase()
                                  })
                                : _vm._e(),
                              !_vm.isPluginHybrid(_vm.engine)
                                ? _c(
                                    "span",
                                    { staticClass: "cd-efficiency-marklabel" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getCo2Class(_vm.engine))
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isPluginHybrid(_vm.engine)
                                ? _c(
                                    "span",
                                    { staticClass: "cd-efficiency-marklabel" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getWltpCo2ClassOnly(_vm.engine)
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm.hasSecondaryCo2Class(_vm.engine)
                                ? _c("span", {
                                    class:
                                      "mark-background secondary efficiency-wltp-" +
                                      _vm
                                        .getWltpSecondaryCo2ClassOnly(
                                          _vm.engine
                                        )
                                        .toLowerCase()
                                  })
                                : _vm._e(),
                              _vm.hasSecondaryCo2Class(_vm.engine)
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cd-efficiency-marklabel secondary"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getWltpSecondaryCo2ClassOnly(
                                            _vm.engine
                                          )
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target:
                                      "energyefficiency-target-" +
                                      _vm.engine.id,
                                    triggers: "hover"
                                  }
                                },
                                [
                                  _c("EnergyEfficiencyBox", {
                                    attrs: { engine: _vm.engine }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                ],
                1
              ),
              _c(
                "b-row",
                {
                  staticClass: "d-flex flex-wrap p-0",
                  attrs: {
                    cols: "12",
                    "align-h": "center",
                    "align-v": "center"
                  }
                },
                [
                  _c("b-col", { staticClass: "cd-carinfo-spec" }, [
                    _c("img", {
                      staticClass: "cd-carinfo-icon",
                      attrs: { src: _vm.enginePowerIcon }
                    }),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label cd-primary-color" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.engine.technical_data.max_power_kw) +
                            "kW/" +
                            _vm._s(_vm.engine.technical_data.max_power_hp) +
                            "PS "
                        )
                      ]
                    ),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label-description" },
                      [_vm._v("Leistung")]
                    )
                  ]),
                  _c("b-col", { staticClass: "cd-carinfo-spec" }, [
                    _c("img", {
                      staticClass: "cd-carinfo-icon",
                      attrs: { src: _vm.fuelTypeIcon }
                    }),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label cd-primary-color" },
                      [_vm._v(" " + _vm._s(_vm.engine.fuel_type) + " ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label-description" },
                      [_vm._v("Kraftstoff")]
                    )
                  ]),
                  _c("b-col", { staticClass: "cd-carinfo-spec" }, [
                    _c("img", {
                      staticClass: "cd-carinfo-icon",
                      attrs: { src: _vm.transmissionIcon }
                    }),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label cd-primary-color" },
                      [_vm._v(" " + _vm._s(_vm.engine.transmission) + " ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "cd-carinfo-data-label-description" },
                      [_vm._v("Getriebe")]
                    )
                  ]),
                  _c(
                    "b-col",
                    {
                      staticClass: "cd-carinfo-visualise ",
                      attrs: { sm: "10", md: "4" }
                    },
                    [
                      _c("CarImage", {
                        staticClass: "rounded",
                        attrs: { imageUrl: _vm.carImageUrl }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }